import React from "react"
import cx from "classnames"
import styles from "./HeaderCards.module.css"
import Image from "next/image";
import Link from "next/link";

const HeaderCards = ({headerTitle, headerTitleBgColor="#212121", data}) => {

    return (
        <>
            {
                data.length >= 3 ? (
                    <div className={cx(styles.container, "d-flex", "flex-column", "align-items-start", "justify-content-start")}>

                        {/* title div */}
                        <div className="w-100 d-flex align-items-center justify-content-start">
                            <div
                                style={{backgroundColor: headerTitleBgColor}}
                                className={cx(styles.titleWrapper, "d-flex", "align-items-center", "justify-content-center")}>
                                <h3 className="m-0 p-0">{headerTitle}</h3>
                            </div>
                        </div>

                        {/*  3 cards wrapper */}

                        <div style={{gap: "10px"}} className="d-flex w-100 flex-column flex-md-row align-items-start justify-content-start">

                            {/* main recomended card*/}
                            <Link
                                href={data[0].link}
                                className={cx(styles.mainRecommendedCardWrapper, "d-flex", 'flex-column', "align-items-start", "justify-content-start")}>
                                <div className={cx(styles.mainRecommendedCardWrapper_imgWarpper, "d-flex", "w-100")}>
                                    <Image unoptimized priority={true} src={data[0].img} alt={data[0].imgAlt} width={100} height={100} />
                                </div>
                                <div className={cx(styles.mainRecommendedCardWrapperInfo, "d-flex", "flex-column", "align-items-start", "justify-content-start", "flex-fill")}>
                                    <span className={cx(styles.mainRecommendedCardWrapper_category, "d-flex")}>{data[0].cat}</span>
                                    <h2 className={cx(styles.mainRecommendedCardWrapper_title, "d-flex")}>{data[0].title}</h2>
                                    <span className={cx(styles.mainRecommendedCardWrapper_date, "d-flex", "mt-auto")}>{data[0].date}</span>
                                </div>
                            </Link>
                            {/* end of main recomended card*/}

                            {/* sub card */}
                            <div className={cx(styles.subRecomendedCardsWrapper, "d-flex", "flex-column", "align-items-start", "justify-content-between", "justify-content-md-start")}>
                                {data[1]?.link && (<Link
                                    href={data[1].link}
                                    className={cx(styles.subRecomendedCards, "d-flex", "flex-column", "flex-md-row", "align-items-start", "justify-content-start", "mt-3", "mt-md-0", "mb-4", "mb-md-0")}>
                                    <div className={cx(styles.subRecomendedCards_imgWarpper, "d-flex")}>
                                        <Image unoptimized priority={true} src={data[1].img} alt={data[1].imgAlt} width={100}
                                               height={100}/>
                                    </div>
                                    <div
                                        className={cx(styles.subRecomendedCardsInfo, "d-flex", "flex-column", "align-items-start", "justify-content-start", "h-100")}>
                                        <span className={cx(styles.subRecomendedCards_category, "d-flex")}>{data[1].cat}</span>
                                        <h2 className={cx(styles.subRecomendedCards_title, "d-flex")}>{data[1].title}</h2>
                                        <span
                                            className={cx(styles.subRecomendedCards_category, "d-flex", "mt-auto")}>{data[1].date}</span>
                                    </div>
                                </Link>)}
                                {data[2]?.link && (<Link
                                    href={data[2].link}
                                    className={cx(styles.subRecomendedCards, "d-flex", "flex-column", "flex-md-row", "align-items-start", "justify-content-start", "mt-md-auto")}>
                                    <div className={cx(styles.subRecomendedCards_imgWarpper, "d-flex")}>
                                        <Image unoptimized priority={true} src={data[2].img} alt={data[2].imgAlt} width={100}
                                               height={100}/>
                                    </div>
                                    <div
                                        className={cx(styles.subRecomendedCardsInfo, "d-flex", "flex-column", "align-items-start", "justify-content-start", "h-100")}>
                                        <span className={cx(styles.subRecomendedCards_category, "d-flex")}>{data[2].cat}</span>
                                        <h2 className={cx(styles.subRecomendedCards_title, "d-flex")}>{data[2].title}</h2>
                                        <span
                                            className={cx(styles.subRecomendedCards_category, "d-flex", "mt-auto")}>{data[2].date}</span>
                                    </div>
                                </Link>)}

                            </div>
                            {/* end of sub card */}

                        </div>
                    </div>
                ) : (
                    <></>
                )
            }
        </>
    )
}

export default HeaderCards